
import { Injectable } from '@angular/core';

import { timeout } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Endpoints } from 'src/app/core/resources/endpoints';
import { Global } from 'src/app/core/resources/global';
import { Filter, FilterModel } from 'src/app/core/models/filter';
import { usesTransportCompanyContext } from 'src/app/core/resources/transport-company-context.utils';
import { environment } from '../../../../environments/environment';
import { Utils } from 'src/app/core/resources/utils';
import { Company } from 'src/app/core/interfaces/company';
import { AuthService } from 'src/app/core/services/authentication.service';
import { DataPaymenCargo } from 'src/app/core/interfaces/dataPaymenCargo';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { CargoItemService } from '../cargo-item/cargo-item.service';
import { CargoBilling } from 'src/app/core/interfaces/cargoBilling';
import { CargoBillingPending } from 'src/app/core/interfaces/cargoBillingPending';
import { Observable } from 'rxjs';
import { BasicResponse } from 'src/app/core/interfaces/basicResponse';
import { AdditionalCostCargo } from 'src/app/core/interfaces/additionalCostCargo';
import { Tax } from 'src/app/core/interfaces/tax';
import { DateFormatPipe } from 'src/app/core/pipe/dateFormat.pipe';
import { EmailStructure } from 'src/app/core/interfaces/emailStructure';
import { DateManager } from 'src/app/core/managers/date.manager';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { Permission } from 'src/app/core/resources/permission';
import { CargoApprovalRequest } from 'src/app/core/interfaces/cargo-approval-request';
import { CargoStateDict, CargoStateEnum } from 'src/app/core/enums/cargoState.enum';
import { TravelExpensesService } from 'src/app/core/services/travel-expenses.service';
import { ApprovalStateEnum, TravelExpense, TravelExpenseDetail } from 'src/app/core/interfaces/travel-expense';
import { ServiceRequests } from 'src/app/core/interfaces/service-requests';
import { ServiceRequestsStates } from 'src/app/core/resources/serviceRequestStates';
import { SelectableItem } from 'src/app/core/interfaces/selectableItem';
import { TRIP_TYPES } from 'src/app/core/enums/tripTypes.enum';
import { TravelExpensesStateEnum } from 'src/app/core/enums/travelExpensesState.enum';
import { FormControl, Validators } from '@angular/forms';
import { Patterns } from 'src/app/core/resources/patterns';
import { Destination } from 'src/app/core/interfaces/destination';
import { LinkedServiceDto } from 'src/app/core/interfaces/linkedServiceDto';
import { Fmt } from 'src/app/core/messages/fmt';
import { Catalog } from 'src/app/core/interfaces/catalog';
import { CargoApprovalRequestBalance } from 'src/app/core/interfaces/cargo-approval-request';
import { CargoPaymentsService } from 'src/app/core/services/cargo-payments.service';
import { ResponseList } from 'src/app/core/interfaces/response-list';
import {
  DOCUMENT_RECREATION_IN_PROGRESS_MESSAGE,
  isDocumentRecreationInProgress
} from 'src/app/core/resources/transport-company-change.utils';
import { SettingId } from 'src/app/core/interfaces/saas-config';
import {
  CargoPaymentPreviewOptions,
  CargoPaymentPreviewRequest,
  CargoPaymentPreviewResponse
} from 'src/app/core/interfaces/bank-account-payment-detail';

@Injectable({
  providedIn: 'root'
})
export class FreightListService {

  permission = Permission;

  constructor(
    private _http: HttpClient,
    private _endpointResources: Endpoints,
    private _globalResources: Global,
    public utils: Utils,
    private authService: AuthService,
    private cargoItemService: CargoItemService,
    private dateFormatPipe: DateFormatPipe,
    public permissionRole: PermissionRole,
    private patterns: Patterns,
    private travelExpensesService: TravelExpensesService,
    private cargoPaymentsService: CargoPaymentsService
  ) {

  }

  // public getListCargo(vehicleType, paramsFilter?) {
  public getListCargo(paramsFilter: string, pageKey?: number, pageSize?: number, typeList?: string): Observable<ResponseList<Cargo>> {
    // vehicleType(Filtro por tipo de vehiculo) Siempre se debe enviar por el vehiculo que active
    // origin
    // destination
    // dateLoad
    // cargoType(Se deben actualizar en las pantallas front)(Carga suelta, Contenedor)
    // initialRank
    // finalRank
    if (paramsFilter.startsWith('&')) {
      paramsFilter = paramsFilter.replace('&', '');
    }
    let url: string = environment.urlServerTeclogi + this._endpointResources.urlCargoList + paramsFilter;

    if (pageKey && pageSize) url += '&pageKey=' + pageKey + '&pageSize=' + pageSize;
    return this._http.get<ResponseList<Cargo>>(
      url
    );
  }

  public getListCargoToPay(paramsFilter: string, pageKey?: number, pageSize?: number): Observable<Cargo[]> {
    if (paramsFilter.startsWith('&')) paramsFilter = paramsFilter.replace('&', '');
    if (pageKey && pageSize) paramsFilter += '&pageKey=' + pageKey + '&pageSize=' + pageSize;
    const url: string = environment.urlServerTeclogi + this._endpointResources.urlCargoListToPay + paramsFilter;

    return this._http.get<Cargo[]>(
      url
    );
  }

  public getListCargoTravelExpenses(paramsFilter: string, pageKey?: number, pageSize?: number) {
    if (paramsFilter.startsWith('&')) paramsFilter = paramsFilter.replace('&', '');
    if (pageKey && pageSize) paramsFilter += '&pageKey=' + pageKey + '&pageSize=' + pageSize;

    type Resource = { cargo: Cargo, travelExpenses: Array<TravelExpense> };

    return this._http
      .get<ResponseList<Resource>>(`${environment.urlServerTeclogi}${this._endpointResources.urlCargoListTravelExpenses}?${paramsFilter}`);
  }

  getListCargoServiceRequests(paramsFilter: string, pageKey?: number, pageSize?: number) {

    let params = new HttpParams();
    if (paramsFilter) {
      paramsFilter.split('&').forEach(param => {
        if (param) {
          const [key, value] = param.split('=');
          if (key && value) {
            params = params.append(key, value);
          }
        }
      });
    }

    if (pageKey && pageSize) {
      params = params.append('pageKey', pageKey.toString());
      params = params.append('pageSize', pageSize.toString());
    }
    return this._http.get<ServiceRequests[]>(
      `${environment.urlServerTeclogi}${this._endpointResources.urlCargoServiceRequests}`,
      { params }
    );
  }

  public getListCargoNegotiation(documentId) {
    return this._http.get(
      environment.urlServerTeclogi + this._endpointResources.urlCargoListNegotiation + documentId
    );
  }

  public getListCargoRequestNegotiation(nit: string, userType: string) {
    return this._http.get(
      // tslint:disable-next-line: max-line-length
      environment.urlServerTeclogi + this._endpointResources.urlCargoRequestListNegotiation + '?idCompany=' + nit + '&userType=' + userType
    );
  }

  public approvedCargo(data: CargoApprovalRequest, state?: boolean): Observable<Cargo[]> {
    let url = environment.urlServerTeclogi + this._endpointResources.approvedCargo;
    if (this.utils.isDefined(state)) url += 'approval=' + state;
    return this._http.post<Cargo[]>(url, data);
  }

  public changeLogisticsTimes(data: CargoApprovalRequest) {
    return this._http.post(`${environment.urlServerTeclogi}${this._endpointResources.changeLogisticsTimes}`, data);
  }

  public approvedCargoBalance(data: CargoApprovalRequestBalance, state?: boolean): Observable<Cargo[]> {
    let url = environment.urlServerTeclogi + this._endpointResources.approvedCargoBalance;
    if (this.utils.isDefined(state)) url += 'approval=' + state;
    return this._http.post<Cargo[]>(url, data);
  }

  public cashedCargo(body: CargoBilling, type: string, transportCompanyId?: string): Observable<BasicResponse> {
    let params = new HttpParams();
    params = params.append('billingType', type);
    params = params.append('userId', this.authService.getUserSession().information.document);
    if (transportCompanyId) params = params.append('transportCompanyId', transportCompanyId);

    return this._http.post<BasicResponse>(
      environment.urlServerTeclogi + this._endpointResources.billingRegister,
      body,
      { params }
    );
  }

  public pendingBillingCargo(body: CargoBillingPending, type: string): Observable<BasicResponse> {
    let params = new HttpParams();
    params = params.append('billingType', type);
    params = params.append('userId', this.authService.getUserSession().information.document);

    return this._http.post<BasicResponse>(
      environment.urlServerTeclogi + this._endpointResources.billingRegister,
      body,
      { params }
    );
  }

  public getFileForPaymentsCargo(data: DataPaymenCargo, state, extraAmount: string, payWithAdditionalCost?: boolean, payWithTravelExpenses?: boolean, actionType?: string) {
    let url = environment.urlServerTeclogi + this._endpointResources.getFileForPayments;
    let config;

    if (extraAmount)
      url += 'extraAdvance' + '&userId=' + this.authService.getUserSession().information.document + '&extraAmount=' + extraAmount;
    else
      url += state + '&userId=' + this.authService.getUserSession().information.document;

    url += `&payWithAdditionalCost=${!!payWithAdditionalCost}`;

    if (this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.payWithTravelExpenses)) {
      url += `&payWithTravelExpenses=${!!payWithTravelExpenses}`;
    }

    if (actionType !== 'fintech') {
      config = {
        responseType: 'blob',
        observe: 'response'
      }
    }

    return this._http.post(
      url,
      data,
      config
    ).pipe(
      timeout(960000)
    );
  }

  /**
   * Previsualiza el pago de los servicios seleccionados: la cuenta bancaria y el
   * valor de cada servicio, y cómo esos servicios se consolidan en las líneas
   * del archivo bancario.
   *
   * Recibe la misma entrada que `getFileForPaymentsCargo` para que los montos
   * del preview coincidan con los que se van a transferir. No escribe nada, así
   * que puede llamarse cada vez que cambie la selección o los switches de pago.
   *
   * Responde 204 (sin cuerpo) cuando no llegó ningún id válido.
   */
  public getCargoPaymentPreview(
    body: CargoPaymentPreviewRequest,
    options: CargoPaymentPreviewOptions
  ): Observable<CargoPaymentPreviewResponse> {
    const url = environment.urlServerTeclogi + this._endpointResources.paymentBankAccounts;
    let params = new HttpParams().set('paymentType', options.paymentType);

    // Los booleanos se omiten cuando vienen sin definir para que el back aplique
    // su valor por defecto, igual que hace `getFileForPaymentsCargo`.
    if (options.payWithAdditionalCost !== undefined && options.payWithAdditionalCost !== null)
      params = params.set('payWithAdditionalCost', `${options.payWithAdditionalCost}`);
    if (options.payWithTravelExpenses !== undefined && options.payWithTravelExpenses !== null)
      params = params.set('payWithTravelExpenses', `${options.payWithTravelExpenses}`);

    return this._http
      .post<CargoPaymentPreviewResponse>(url, body, { params })
      .pipe(timeout(30000));
  }

  // Objeto privado con tipado fuerte para los filtros disponibles
  private readonly optionsFilter: { [key: string]: FilterModel } = {
    showFilterErrorManifest: {
      filterName: Filter.showFilterErrorManifest,
      title: 'Error en manifiesto',
      validations: this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.showManifestError),
      controls: { errorManifest: new FormControl('') },
      type: 'checkbox',
      typeFilter: 'dynamic'
    },
    showFilterMultipleCompanies: {
      filterName: Filter.showFilterMultipleCompanies,
      title: 'Añadir compañía',
      validations: !!this.authService.userIsFromRootNit(),
      controls: { nits: new FormControl([]) },
      type: 'other',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, nits: string[]) => nits.some(nit => nit === cargo.idCompany)
    },
    showFilterCompany: {
      filterName: Filter.showFilterCompany,
      title: 'Compañía',
      validations: !!this.authService.userIsFromRootNit(),
      controls: { exclusive: new FormControl(''), nit: new FormControl('') },
      type: 'other',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, exclusive: string, nit: string) => cargo.idCompany === nit
    },
    showFilterTransportCompany: {
      filterName: Filter.showFilterTransportCompany,
      title: 'Empresa de transporte',
      validations: true,
      controls: { transportCompanyId: new FormControl('') },
      type: 'select',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, transportCompanyId: string) =>
        this.utils.getNestedValue(cargo, 'transportCompany.id') === transportCompanyId
    },
    // Misma condición que showFilterTransportCompany, pero siempre aplicada con la
    // pastilla de list-filter (ver usesTransportCompanyContext).
    showFilterTransportCompanyContext: {
      filterName: Filter.showFilterTransportCompanyContext,
      title: 'Empresa de transporte',
      controls: { transportCompanyId: '' },
      type: 'other',
      typeFilter: 'context',
      acceptanceFunction: (cargo: Cargo, transportCompanyId: string) =>
        this.utils.getNestedValue(cargo, 'transportCompany.id') === transportCompanyId
    },
    showfilterlicensePlate: {
      filterName: Filter.showfilterlicensePlate,
      title: 'Placa',
      validations: true,
      controls: { licensePlate: new FormControl('', [Validators.minLength(5), Validators.maxLength(8), Validators.pattern(this.patterns.GET_REGEX('LICENSE_PLATES').source)]) },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, licensePlate: string) => {
        const cargoLicensePlate = this.utils.getNestedValue(cargo, 'licensePlate');
        if (!cargoLicensePlate) return false;
        return cargoLicensePlate.toLowerCase() === licensePlate.toLowerCase()
      }
    },
    showFilterVehicleTrailerId: {
      filterName: Filter.showFilterVehicleTrailerId,
      title: 'Trailer',
      validations: true,
      controls: { trailerId: new FormControl('') },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, trailerId: string) => {
        const cargoTrailerId = this.utils.getNestedValue(cargo, 'trailerId');
        if (!cargoTrailerId) return false;
        return cargoTrailerId.toLowerCase() === trailerId.toLowerCase();
      }
    },
    showfilterEscortedLicensePlate: {
      filterName: Filter.showfilterEscortedLicensePlate,
      title: 'Placa escoltada',
      validations: true,
      controls: { escortedLicensePlate: new FormControl('', [Validators.minLength(5), Validators.maxLength(8), Validators.pattern(this.patterns.GET_REGEX('LICENSE_PLATES').source)]) },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, escortedLicensePlate: string) => {
        const cargoEscortedLicensePlate = this.utils.getNestedValue(cargo, 'escortedVehicle.licensePlate');
        if (!cargoEscortedLicensePlate) return false;
        return cargoEscortedLicensePlate.toLowerCase() === escortedLicensePlate.toLowerCase()
      }
    },
    showFilterImeiLock: {
      filterName: Filter.showFilterImeiLock,
      title: 'IMEI del candado satelital',
      validations: true,
      controls: { imeiLock: new FormControl('') },
      type: 'input',
      typeFilter: 'dynamic'
    },
    showFilterLockId: {
      filterName: Filter.showFilterLockId,
      title: 'ID del candado satelital',
      validations: true,
      controls: { lockId: new FormControl('') },
      type: 'input',
      typeFilter: 'dynamic'
    },
    showFilterTypeNameLock: {
      filterName: Filter.showFilterTypeNameLock,
      title: 'Tipo del candado satelital',
      validations: true,
      controls: { typeNameLock: new FormControl('') },
      type: 'select',
      typeFilter: 'dynamic'
    },
    showFilterDate: {
      filterName: Filter.showFilterDate,
      title: ['Desde', 'Hasta'],
      validations: true,
      controls: { dateLoad: new FormControl(''), endDate: new FormControl('') },
      type: 'other',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, dateLoad?: string, endDate?: string) => {
        const cargoDateLoad = DateManager.stringToDate(cargo.dateLoad);
        if (dateLoad) {
          const dateLoadDate = DateManager.stringToDate(dateLoad, 'YYYY-MM-DD ZZ');
          if (DateManager.isBefore(cargoDateLoad, dateLoadDate)) return false;
        }
        if (endDate) {
          const endDateDate = DateManager.stringToDate(endDate, 'YYYY-MM-DD ZZ');
          if (DateManager.isBefore(endDateDate, cargoDateLoad)) return false;
        }
        return true;
      }
    },
    showFilterCreationDateInitial: {
      filterName: Filter.showFilterCreationDateInitial,
      title: 'Desde',
      validations: true,
      controls: { creationDateInitial: new FormControl('') },
      type: 'other',
      typeFilter: 'dynamic',
      acceptanceFunction: () => true
    },
    showFilterCreationDateFinal: {
      filterName: Filter.showFilterCreationDateFinal,
      title: 'Hasta',
      validations: true,
      controls: { creationDateFinal: new FormControl('') },
      type: 'other',
      typeFilter: 'dynamic',
      acceptanceFunction: () => true
    },
    showFilterByTag: {
      filterName: Filter.showFilterByTag,
      title: 'Etiqueta',
      validations: true,
      controls: { labels: new FormControl('') },
      type: 'select',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, labels: string[]) => labels && labels.length &&
        labels.some(label => cargo.labels && cargo.labels.includes(label))
    },
    showFilterLastPointExistance: {
      filterName: Filter.showFilterLastPointExistance,
      title: 'Último seguimiento registrado',
      validations: true,
      controls: { lastPointExistance: new FormControl('') },
      type: 'select',
      typeFilter: 'dynamic',
      options: [
        { value: 'true', label: 'Con seguimientos' },
        { value: 'false', label: 'Sin seguimientos' }
      ]
    },
    showFilterLastPointLapse: {
      filterName: Filter.showFilterLastPointLapse,
      title: 'Lapso a último seguimiento',
      validations: true,
      controls: { lastPointLapse: new FormControl('') },
      type: 'input',
      typeFilter: 'dynamic'
    },
    showFilterContainerExpirationLapse: {
      filterName: Filter.showFilterContainerExpirationLapse,
      title: 'Lapso a expiración',
      validations: true,
      controls: { containerExpirationLapse: new FormControl('') },
      type: 'input',
      typeFilter: 'dynamic'
    },
    showfilterIdCargo: {
      filterName: Filter.showfilterIdCargo,
      title: 'Nº ID servicio',
      validations: true,
      controls: { consecutive: new FormControl('', [Validators.pattern(this.patterns.ONLY_NUMBERS.source), Validators.minLength(1), Validators.maxLength(10)]) },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, consecutive: string) => cargo.consecutive === Number(consecutive)
    },
    showFilterMainConsecutive: {
      filterName: Filter.showFilterMainConsecutive,
      title: 'Nº ID consolidado base',
      validations: true,
      controls: { consecutiveMainCargo: new FormControl('', [Validators.pattern(this.patterns.ONLY_NUMBERS.source), Validators.minLength(1), Validators.maxLength(10)]) },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, consecutiveMainCargo: string) => cargo.consecutiveMainCargo === Number(consecutiveMainCargo)
    },
    showFilterContainer: {
      filterName: Filter.showFilterContainer,
      title: 'Contenedor',
      validations: true,
      controls: { container: new FormControl('', [Validators.pattern(this.patterns.CONTAINER_FORMAT_FULL.source), Validators.minLength(11), Validators.maxLength(11)]) },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, container: string) => cargo.container === container || (cargo.containers || []).includes(container)
    },
    showFilterCategory: {
      filterName: Filter.showFilterCategory,
      validations: true,
      controls: { tripCategory: new FormControl('') },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, tripCategory: string) => this.utils.getNestedValue(cargo, 'cargoModel.tripType.category') === tripCategory
    },
    showFilterPublicationZone: {
      filterName: Filter.showFilterPublicationZone,
      validations: true,
      controls: { zone: new FormControl('') },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, zone: string) => cargo.zone === zone
    },
    showFilterPrevalidationValid: {
      filterName: Filter.showFilterPrevalidationValid,
      validations: true,
      controls: { prevalidationValid: new FormControl('') },
      type: 'select',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, preValidationValid: boolean) => !!this.utils.getNestedValue(cargo, 'prevalidation.valid') === preValidationValid
    },
    showFilterRequiresPreBill: {
      filterName: Filter.showFilterRequiresPreBill,
      validations: true,
      controls: { requiresPreBill: new FormControl('') },
      type: 'select',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, requiresPreBill: boolean) => !!this.utils.getNestedValue(cargo, 'requiresPreBill') === requiresPreBill
    },
    showFilterPreBill: {
      filterName: Filter.showFilterPreBill,
      validations: true,
      controls: { preBill: new FormControl('') },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, preBill: boolean) => this.utils.getNestedValue(cargo, 'preBill') === preBill
    },
    showFilterNumberDocument: {
      filterName: Filter.showFilterNumberDocument,
      validations: true,
      controls: { numberDocumentSender: new FormControl('') },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, numberDocumentSender: string) => cargo.numberDocumentSender === numberDocumentSender
    },
    showfilterManifestCargo: {
      filterName: Filter.showfilterManifestCargo,
      validations: true,
      controls: { manifest: new FormControl('') },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, manifest: string) => cargo.manifest === manifest
    },
    showfilterIdBill: {
      filterName: Filter.showfilterIdBill,
      validations: true,
      controls: { billId: new FormControl('') },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, billId: string) => this.utils.getNestedValue(cargo, 'shippingCost.billId') === billId
    },
    showFilterTripTypeName: {
      filterName: Filter.showFilterTripTypeName,
      validations: true,
      controls: { tripTypeName: new FormControl('') },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, tripTypeName: string) => this.utils.getNestedValue(cargo, 'cargoModel.tripType.name') === tripTypeName
    },
    showFilterRegimeType: {
      filterName: Filter.showFilterRegimeType,
      validations: true,
      controls: { regimenType: new FormControl('') },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, regimenType: string) => this.utils.getNestedValue(cargo, 'cargoModel.tripType.regimeType') === regimenType
    },
    showFilterRiskProfile: {
      filterName: Filter.showFilterRiskProfile,
      title: 'Perfil de riesgo',
      validations: true,
      controls: { riskProfileId: new FormControl('') },
      type: 'select',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, riskProfileId: string) => `${this.utils.getNestedValue(cargo, 'riskProfile.id')}` === `${riskProfileId}`
    },
    showFilterFintech: {
      filterName: Filter.showFilterFintech,
      validations: true,
      controls: { fastPayment: new FormControl('') },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, fastPayment: boolean | string) => {
        if (typeof fastPayment === 'string') return cargo.fastPayment === (fastPayment === 'true');
        return cargo.fastPayment === fastPayment;
      }
    },
    showFilterApprovalState: {
      filterName: Filter.showFilterApprovalState,
      validations: true,
      controls: { approval: new FormControl('') },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, approval: string) => approval ? cargo.approval === approval : true
    },
    showFilterConfirmedDriver: {
      filterName: Filter.showFilterConfirmedDriver,
      validations: true,
      controls: { confirmedDriver: new FormControl('') },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, confirmedDriver: boolean | string) => {
        if (typeof confirmedDriver === 'string') return cargo.confirmedDriver === (confirmedDriver === 'true');
        return cargo.confirmedDriver === confirmedDriver;
      }
    },
    showFilterAmount: {
      filterName: Filter.showFilterAmount,
      validations: true,
      controls: { startAmount: new FormControl(''), endAmount: new FormControl('') },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, startAmount: string, endAmount: string) => {
        const cargoAmount = Number(this.utils.getNestedValue(cargo, 'cargoFeature.cargoMeasure.amount'));
        if (startAmount && cargoAmount < Number(startAmount)) return false;
        if (endAmount && cargoAmount > Number(endAmount)) return false;
        return true;
      }
    },
    showFilterIncident: {
      filterName: Filter.showFilterIncident,
      validations: true,
      controls: { news: new FormControl('') },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, news: string) => {
        const incident = this.cargoItemService.getIndicator(cargo);
        return incident && incident.name === news;
      }
    },
    showFilterCargoConsecutive: {
      filterName: Filter.showFilterCargoConsecutive,
      validations: true,
      controls: { cargoConsecutive: new FormControl('') },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, cargoConsecutive: string) => cargo.consecutive === Number(cargoConsecutive)
    },
    showFilterExpensesApproval: {
      filterName: Filter.showFilterExpensesApproval,
      validations: true,
      controls: { approval: new FormControl('') },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: () => true
    },
    showFilterExpensesPaid: {
      filterName: Filter.showFilterExpensesPaid,
      validations: true,
      controls: { paid: new FormControl('') },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: () => true
    },
    showFilterOriginDestination: {
      filterName: Filter.showFilterOriginDestination,
      validations: true,
      controls: { origin: new FormControl(''), destination: new FormControl('') },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, origin: string, destination: string) => {
        if (!origin && !destination) return true;
        const originCity = this.utils.getNestedValue(cargo, 'cargoFeature.uploadDownload.origin.name');
        const destinations: Destination[] = this.utils.getNestedValue(cargo, 'cargoFeature.uploadDownload.destination');
        if (origin && originCity !== origin) return false;
        if (destination && (!destinations || !destinations.length || !destinations.some(dest => dest.name === destination))) return false;
        return true;
      }
    },
    showFilterNumberDocumentDriver: {
      filterName: Filter.showFilterNumberDocumentDriver,
      validations: true,
      controls: { driver: new FormControl('', [Validators.pattern(this.patterns.ONLY_NUMBERS.source), Validators.minLength(2)]) },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: (cargo: Cargo, driver: string) => cargo.driver === driver
    },
    showFilterUserClient: {
      filterName: Filter.showFilterUserClient,
      title: 'Usuario web',
      validations: true,
      controls: { userClientDocument: new FormControl('') },
      type: 'input',
      typeFilter: 'dynamic',
      acceptanceFunction: () => true
    },
    //Static Filters
    showFilterTravelExpensesState: {
      filterName: Filter.showFilterTravelExpensesState,
      validations: true,
      controls: { travelExpenseGlobalStatus: 'notLegalized', approveBalance: false, states: [CargoStateEnum.REQUEST, CargoStateEnum.CREATED, CargoStateEnum.START_SERVICE, CargoStateEnum.ACCEPTED, CargoStateEnum.END_SERVICE] },
      type: 'select',
      typeFilter: 'static',
      options: []
    },
    showFilterAprovedCargo: {
      filterName: Filter.showFilterAprovedCargo,
      validations: true,
      controls: { approval: 'all' },
      type: 'select',
      typeFilter: 'static',
      options: []
    },
    showFilterMinistryFulfillment: {
      filterName: Filter.showFilterMinistryFulfillment,
      validations: true,
      controls: { ministryFulfillment: 'all' },
      type: 'select',
      typeFilter: 'static',
      options: []
    },
    showFilterAssignmentsCargo: {
      filterName: Filter.showFilterAssignmentsCargo,
      validations: true,
      controls: { approval: "Pending approval" },
      type: 'select',
      typeFilter: 'static',
      options: []
    },
    showFilterPaymentBalanceCargo: {
      filterName: Filter.showFilterPaymentBalanceCargo,
      validations: true,
      controls: { fastPayment: "", paid: "", approval: "Approved", paymentType: "balance" },
      type: 'select',
      typeFilter: 'static',
      options: []
    },
    showFilterPaymentAdvanceCargo: {
      filterName: Filter.showFilterPaymentAdvanceCargo,
      validations: true,
      controls: { requestedAdvance: true, advanceState: false, states: [CargoStateEnum.START_SERVICE, CargoStateEnum.ACCEPTED] },
      type: 'select',
      typeFilter: 'static',
      options: []
    },
    showFilterPaymentAdditionalCostsCargo: {
      filterName: Filter.showFilterPaymentAdditionalCostsCargo,
      validations: true,
      controls: { additionalCost: "Servicio cargue", additionalCostPaid: false, states: [CargoStateEnum.START_SERVICE, CargoStateEnum.END_SERVICE] },
      type: 'select',
      typeFilter: 'static',
      options: []
    },
    showFilterDriver: {
      filterName: Filter.showFilterDriver,
      validations: true,
      controls: { state: CargoStateEnum.ACCEPTED },
      type: 'select',
      typeFilter: 'static',
      options: []
    },
    showFilterCharges: {
      filterName: Filter.showFilterCharges,
      validations: true,
      controls: { ministryFulfillment: 'all', cashed: false, checked: "", states: [CargoStateEnum.START_SERVICE, CargoStateEnum.END_SERVICE] },
      type: 'select',
      typeFilter: 'static',
      options: []
    },
    showFilterRaiting: {
      filterName: Filter.showFilterRaiting,
      validations: true,
      controls: { qualified: "" },
      type: 'select',
      typeFilter: 'static',
      options: []
    },
    showFilterTransportRequests: {
      filterName: Filter.showFilterTransportRequests,
      validations: true,
      controls: { states: [CargoStateEnum.ACCEPTED, CargoStateEnum.REQUEST], assignedDriver: true },
      type: 'select',
      typeFilter: 'static',
      options: []
    },
    showFilterPaymentState: {
      filterName: Filter.showFilterPaymentState,
      validations: true,
      controls: { paid: "" },
      type: 'select',
      typeFilter: 'static',
      options: []
    },
    showFilterWithoutPayment: {
      filterName: Filter.showFilterWithoutPayment,
      validations: true,
      controls: { journal: false, states: [CargoStateEnum.START_SERVICE, CargoStateEnum.END_SERVICE], journalError: "" },
      type: 'select',
      typeFilter: 'static',
      options: []
    },
    showFilterOrderByTracking: {
      filterName: Filter.showFilterOrderByTracking,
      validations: true,
      controls: { orderBy: 'oldFirst' },
      type: 'select',
      typeFilter: 'static',
      options: []
    },
    showFilterPaymentExpenses: {
      filterName: Filter.showFilterPaymentExpenses,
      validations: true,
      controls: { travelExpensesType: new FormControl('') },
      type: 'select',
      typeFilter: 'static'
    },
    showFilterPaymentExpensesPaymentType: {
      filterName: Filter.showFilterPaymentExpensesPaymentType,
      validations: true,
      controls: { paid: new FormControl('') },
      type: 'select',
      typeFilter: 'static'
    },
    showFilterPaymentExtraAdvanceCargo: {
      filterName: Filter.showFilterPaymentExtraAdvanceCargo,
      validations: true,
      controls: {
        advanceState: true, paymentType: "advance", states: this.isTeclogiUser
          ? [CargoStateEnum.START_SERVICE, CargoStateEnum.ACCEPTED, CargoStateEnum.END_SERVICE]
          : [CargoStateEnum.START_SERVICE, CargoStateEnum.ACCEPTED]
      },
      type: 'select',
      typeFilter: 'static'
    },
    showFilterPrevalidation: {
      filterName: Filter.showFilterPrevalidation,
      validations: true,
      controls: { prevalidationValid: "Pending validation", states: [CargoStateEnum.START_SERVICE, CargoStateEnum.END_SERVICE] },
      type: 'select',
      typeFilter: 'static'
    },
  };

  public getOptionsFilter(typeList: string): FilterModel[] {
    if (Object.keys(ServiceRequestsStates).includes(typeList)) //Solicitudes de servicio
      return [
        this.optionsFilter.showfilterIdCargo,
        this.optionsFilter.showFilterDate,
        this.optionsFilter.showFilterPublicationZone
      ];
    const standardFilters = [
      this.optionsFilter.showFilterContainer,
      this.optionsFilter.showFilterTripTypeName,
      this.optionsFilter.showFilterCompany,
      usesTransportCompanyContext(typeList)
        ? this.optionsFilter.showFilterTransportCompanyContext
        : this.optionsFilter.showFilterTransportCompany,
      this.optionsFilter.showfilterlicensePlate,
      this.optionsFilter.showfilterManifestCargo,
      this.optionsFilter.showfilterIdCargo,
      this.optionsFilter.showfilterIdBill,
      this.optionsFilter.showFilterOriginDestination,
      this.optionsFilter.showFilterByTag,
      this.optionsFilter.showFilterCategory,
      this.optionsFilter.showFilterRiskProfile,
    ];

    if (this.authService && this.authService.hasEscortServicesCompany)
      standardFilters.push(this.optionsFilter.showfilterEscortedLicensePlate);

    if (this.authService && this.authService.hasSatelliteLockServicesCompany) {
      standardFilters.push(this.optionsFilter.showFilterImeiLock);
      standardFilters.push(this.optionsFilter.showFilterLockId);
      standardFilters.push(this.optionsFilter.showFilterTypeNameLock);
    }

    if (this.authService && this.authService.getUserSession().clientCompanyId === environment.rootNit) {
      if (["approvePayments", "paymentAdvanceCargo", "paymentExtraAdvanceCargo",
        "paymentAdditionalCostsCargo", "paymentBalanceCargo"].includes(typeList)) {
        standardFilters.push(this.optionsFilter.showFilterMultipleCompanies);
        standardFilters.splice(standardFilters.indexOf(this.optionsFilter.showFilterCompany), 1);
      }
    }

    switch (typeList) {
      case 'globalTracking': //Tracking global
        return [
          ...standardFilters,
          this.optionsFilter.showFilterMultipleCompanies,
          this.optionsFilter.showFilterIncident,
          this.optionsFilter.showFilterAmount,
          this.optionsFilter.showFilterNumberDocumentDriver,
          this.optionsFilter.showFilterVehicleTrailerId
        ];
      case 'scheduledLoads': //Cargas programadas
        return [
          ...standardFilters.filter(filter => filter && ![Filter.showfilterIdBill].includes(filter.filterName)),
          this.optionsFilter.showFilterDate,
          this.optionsFilter.showFilterMainConsecutive,
          this.optionsFilter.showFilterDriver,
          this.optionsFilter.showFilterNumberDocument,
          this.optionsFilter.showFilterConfirmedDriver,
          this.optionsFilter.showFilterPublicationZone,
          this.optionsFilter.showFilterErrorManifest
        ];
      case 'expired': //Cargas expiradas
        return [
          ...standardFilters,
          this.optionsFilter.showFilterDate,
          this.optionsFilter.showFilterNumberDocument,
        ];
      case 'loadsFinished': //Cargas finalizadas
        return [
          ...standardFilters,
          this.optionsFilter.showFilterDate,
          this.optionsFilter.showFilterMainConsecutive,
          this.optionsFilter.showFilterNumberDocument,
          this.optionsFilter.showFilterRaiting,
          this.optionsFilter.showFilterNumberDocumentDriver,
          this.optionsFilter.showFilterVehicleTrailerId
        ];
      case 'prevalidation': //Prevalidación de servicios
        return [
          ...standardFilters,
          this.optionsFilter.showFilterDate,
          this.optionsFilter.showFilterMainConsecutive,
          this.optionsFilter.showFilterNumberDocument,
          this.optionsFilter.showFilterPrevalidation,
          this.optionsFilter.showFilterNumberDocumentDriver,
          this.optionsFilter.showFilterUserClient,
          this.optionsFilter.showFilterVehicleTrailerId
        ];
      case 'approvePayments': //Aprobación de cargas
        return [
          ...standardFilters,
          this.optionsFilter.showFilterDate,
          this.optionsFilter.showFilterMainConsecutive,
          this.optionsFilter.showFilterNumberDocument,
          this.optionsFilter.showFilterAprovedCargo,
          this.optionsFilter.showFilterPaymentState,
          this.optionsFilter.showFilterFintech,
          this.optionsFilter.showFilterNumberDocumentDriver
        ];
      case 'rndcFulfillments': //Cumplidos RNDC
        return [
          ...standardFilters,
          this.optionsFilter.showFilterDate,
          this.optionsFilter.showFilterMainConsecutive,
          this.optionsFilter.showFilterNumberDocument,
          this.optionsFilter.showFilterMinistryFulfillment,
          this.optionsFilter.showFilterFintech,
          this.optionsFilter.showFilterNumberDocumentDriver
        ];
      case 'travelExpensesChecking': //Consulta de viáticos
        return [
          ...standardFilters,
          this.optionsFilter.showFilterDate,
          this.optionsFilter.showFilterNumberDocument,
          this.optionsFilter.showFilterTravelExpensesState,
          this.optionsFilter.showFilterNumberDocumentDriver
        ];
      case 'paymentAdvanceCargo': //Pago de anticipo
        return [
          ...standardFilters,
          this.optionsFilter.showFilterDate,
          this.optionsFilter.showFilterMainConsecutive,
          this.optionsFilter.showFilterNumberDocument,
          this.optionsFilter.showFilterPaymentAdvanceCargo,
          this.optionsFilter.showFilterNumberDocumentDriver
        ];
      case 'paymentExtraAdvanceCargo': //Pago de extra anticipo
        return [
          ...standardFilters,
          this.optionsFilter.showFilterDate,
          this.optionsFilter.showFilterMainConsecutive,
          this.optionsFilter.showFilterNumberDocument,
          this.optionsFilter.showFilterPaymentExtraAdvanceCargo,
          this.optionsFilter.showFilterNumberDocumentDriver
        ];
      case 'paymentAdditionalCostsCargo': //Pago de costos adicionales
        return [
          ...standardFilters,
          this.optionsFilter.showFilterDate,
          this.optionsFilter.showFilterMainConsecutive,
          this.optionsFilter.showFilterNumberDocument,
          this.optionsFilter.showFilterPaymentAdditionalCostsCargo,
          this.optionsFilter.showFilterNumberDocumentDriver
        ];
      case 'paymentBalanceCargo': //Pago de saldo
        return [
          ...standardFilters,
          this.optionsFilter.showFilterDate,
          this.optionsFilter.showFilterMainConsecutive,
          this.optionsFilter.showFilterNumberDocument,
          this.optionsFilter.showFilterPaymentBalanceCargo,
          this.optionsFilter.showFilterNumberDocumentDriver,
          this.optionsFilter.showFilterApprovalState
        ];
      case 'paymentTravelExpenses': //Pago de viáticos
        return [
          ...standardFilters,
          this.optionsFilter.showFilterExpensesApproval,
          this.optionsFilter.showFilterMainConsecutive,
          this.optionsFilter.showFilterExpensesPaid,
          this.optionsFilter.showFilterPaymentExpenses,
          this.optionsFilter.showFilterPaymentExpensesPaymentType,
          this.optionsFilter.showFilterCargoConsecutive,
          this.optionsFilter.showFilterNumberDocumentDriver
        ];
      case 'charges': //Facturación
        return [
          ...standardFilters,
          this.optionsFilter.showFilterDate,
          this.optionsFilter.showFilterMainConsecutive,
          this.optionsFilter.showFilterNumberDocument,
          this.optionsFilter.showFilterCharges,
          this.optionsFilter.showFilterNumberDocumentDriver,
          this.optionsFilter.showFilterPrevalidationValid,
          this.optionsFilter.showFilterRequiresPreBill,
          this.optionsFilter.showFilterPreBill
        ];
      case 'deleted': //Eliminadas
        return [
          ...standardFilters,
          this.optionsFilter.showFilterDate,
          this.optionsFilter.showFilterMainConsecutive,
          this.optionsFilter.showFilterNumberDocument,
        ];
      case 'request': //Solicitudes
        return [
          ...standardFilters.filter(filter => filter && ![Filter.showfilterManifestCargo, Filter.showfilterIdBill].includes(filter.filterName)),
          this.optionsFilter.showFilterDate,
          this.optionsFilter.showFilterNumberDocument,
          this.optionsFilter.showFilterMainConsecutive,
          this.optionsFilter.showFilterPublicationZone
        ];
      case 'loadingRoutes': //Cargas en ruta
      case 'urbanRoutes': //Cargas en ruta
      case 'nationalRoutes': //Cargas en ruta
      case 'exportRoutes': //Cargas en ruta
      case 'importRoutes': //Cargas en ruta
      case 'lastMileRoutes': //Cargas en ruta
      case 'internationalRoutes': //Cargas en ruta
        return [
          ...standardFilters,
          this.optionsFilter.showFilterMultipleCompanies,
          this.optionsFilter.showFilterMainConsecutive,
          this.optionsFilter.showFilterDate,
          this.optionsFilter.showFilterNumberDocument,
          this.optionsFilter.showFilterIncident,
          this.optionsFilter.showFilterAmount,
          this.optionsFilter.showFilterRegimeType,
          this.optionsFilter.showFilterLastPointExistance,
          this.optionsFilter.showFilterLastPointLapse,
          this.optionsFilter.showFilterOrderByTracking,
          this.optionsFilter.showFilterNumberDocumentDriver,
          this.optionsFilter.showFilterVehicleTrailerId,
          this.optionsFilter.showFilterErrorManifest
        ];
      case 'emptyContainers': //Cargas en ruta
        return [
          ...standardFilters,
          this.optionsFilter.showFilterContainerExpirationLapse,
          this.optionsFilter.showFilterMainConsecutive,
          this.optionsFilter.showFilterDate,
          this.optionsFilter.showFilterNumberDocument,
          this.optionsFilter.showFilterIncident,
          this.optionsFilter.showFilterAmount,
          this.optionsFilter.showFilterRegimeType,
          this.optionsFilter.showFilterLastPointExistance,
          this.optionsFilter.showFilterLastPointLapse,
          this.optionsFilter.showFilterOrderByTracking,
          this.optionsFilter.showFilterNumberDocumentDriver,
          this.optionsFilter.showFilterVehicleTrailerId
        ];
      case 'withoutPayment': //Gastos e ingresos
        return [
          ...standardFilters,
          this.optionsFilter.showFilterNumberDocument,
          this.optionsFilter.showFilterWithoutPayment,
          this.optionsFilter.showFilterCreationDateInitial,
          this.optionsFilter.showFilterCreationDateFinal
        ];
      case 'transportRequests': //Solicitudes de servicio asignadas
        return [
          ...standardFilters.filter(filter => filter && ![Filter.showfilterManifestCargo, Filter.showfilterIdBill].includes(filter.filterName)),
          this.optionsFilter.showFilterTransportRequests,
          this.optionsFilter.showFilterMainConsecutive,
          this.optionsFilter.showFilterDate,
          this.optionsFilter.showFilterNumberDocument,
          this.optionsFilter.showFilterConfirmedDriver,
          this.optionsFilter.showFilterNumberDocumentDriver
        ];
    }

    return standardFilters;
  }

  public getStatesByTypeList(typeList: string): CargoStateEnum[] {
    let value = [];
    switch (typeList) {
      case 'withoutPayment':
        value.push(CargoStateEnum.END_SERVICE);
        value.push(CargoStateEnum.START_SERVICE);
        break;
    };
    return value;
  };

  public getStateTypeList(typeList: String, filterDriver?: boolean): CargoStateEnum {
    let stateType: CargoStateEnum = null;
    switch (typeList) {
      case 'loadingRoutes':
      case 'advance':
      case 'emptyContainers':
      case 'urbanRoutes':
      case 'lastMileRoutes':
      case 'nationalRoutes':
      case 'exportRoutes':
      case 'importRoutes':
      case 'internationalRoutes':
        stateType = CargoStateEnum.START_SERVICE;
        break;
      case 'scheduledLoads':
        stateType = CargoStateEnum.CREATED;
        if (filterDriver) {
          stateType = CargoStateEnum.ACCEPTED;
        }
        break;
      case 'loadsFinished':
      case 'balance':
      case 'approvePayments':
      case 'rndcFulfillments':
        stateType = CargoStateEnum.END_SERVICE;
        break;
      case 'request':
        stateType = CargoStateEnum.REQUEST;
        break;
      case 'expired':
        stateType = CargoStateEnum.EXPIRED;
        break;
      case 'deleted':
        stateType = CargoStateEnum.DELETED;
        break;
    }
    return stateType;
  }

  public getCargoAvailableToList(cargo: Cargo, typeList: string, filtersAsString: string): { isAvailable: boolean, reason: string } {
    const filters = this.utils.decodeFilters(filtersAsString);
    const arrayKeys = ['nits', 'labels'];
    for (const key of arrayKeys) {
      if (filters[key] && filters[key].length)
        filters[key] = filters[key].map((item: string) => item.replace(/^\["?/, '').replace(/"?\]$/, '').replace(/"/g, ''));
    }
    //Validaciones de filtros adicionales
    const filtersByTypeList = this.getOptionsFilter(typeList);
    const dynamicFilters = filtersByTypeList.filter(filter => filter && ['dynamic', 'context'].includes(filter.typeFilter));
    for (const filter of dynamicFilters) {
      if (filter && filter.acceptanceFunction && filter.controls && Object.keys(filter.controls).length) {
        const controlsKeys = Object.keys(filter.controls);
        const controlsValues = controlsKeys.map(key => filters[key]);
        const isSomeFilterApplied = controlsValues.some(val => val !== null && val !== undefined && val !== "");
        if (isSomeFilterApplied) {
          const result = filter.acceptanceFunction(cargo, ...controlsValues);
          if (!result) return { isAvailable: false, reason: `El servicio ya no aplica bajo el filtro de ${filter.filterName.toLowerCase()}` };
        }
      }
    }

    //Solicitudes
    if (typeList === 'request') {
      const isRequest = cargo.state === CargoStateEnum.REQUEST;
      return { isAvailable: isRequest, reason: isRequest ? '' : `no aplica en el estado de ${CargoStateDict[cargo.state]}.` };
    }

    //Solicitudes de servicio
    if (typeList === 'transportRequests') {
      if (filters['assignedDriver'] === 'true') {
        const allowedStates = [CargoStateEnum.ACCEPTED, CargoStateEnum.REQUEST];
        if (!allowedStates.includes(cargo.state))
          return {
            isAvailable: false,
            reason: `el servicio ya no está en un estado válido. Estados válidos: ${allowedStates.map(state => CargoStateDict[state]).join(',')}.`
          };
        const isAssignedDriver = cargo.assignedDriver;
        return { isAvailable: isAssignedDriver, reason: isAssignedDriver ? '' : `el servicio ya no tiene un conductor asignado.` };
      } else {
        const allowedStates = [CargoStateEnum.CREATED, CargoStateEnum.REQUEST];
        if (!allowedStates.includes(cargo.state))
          return {
            isAvailable: false,
            reason: `el servicio ya no está en un estado válido. Estados válidos: ${allowedStates.map(state => CargoStateDict[state]).join(',')}.`
          };
        const isAssignedDriver = cargo.assignedDriver;
        return { isAvailable: !isAssignedDriver, reason: !isAssignedDriver ? '' : `el servicio ya tiene un conductor asignado.` };
      }
    }

    // Programadas
    if (typeList === 'scheduledLoads') {
      if (filters['state'] === 'Created') {
        const validState = cargo.state === CargoStateEnum.CREATED;
        return { isAvailable: validState, reason: validState ? '' : `el servicio ya no está en un estado válido. Estados válidos: ${CargoStateDict[CargoStateEnum.CREATED]}` };
      }
      if (filters['state'] === 'Accepted') {
        const validState = cargo.state === CargoStateEnum.ACCEPTED;
        return { isAvailable: validState, reason: validState ? '' : `el servicio ya no está en un estado válido. Estados válidos: ${CargoStateDict[CargoStateEnum.ACCEPTED]}` };
      }
      return { isAvailable: false, reason: "el servicio ya no está en un estado válido." }
    }
    // En ruta
    if (typeList === 'loadingRoutes') {
      const validState = cargo.state === CargoStateEnum.START_SERVICE;
      return { isAvailable: validState, reason: validState ? '' : `el servicio ya no está en un estado válido. Estados válidos: ${CargoStateDict[CargoStateEnum.START_SERVICE]}` };
    }
    if (typeList === 'emptyContainers') {
      const serviceTypeName = this.utils.getNestedValue(cargo, 'cargoModel.serviceType.name');
      const isEmptyContainer = ['Contenedor vacío con carga de compensación', 'Contenedor vacío express'].includes(serviceTypeName);
      const validState = cargo.state === CargoStateEnum.START_SERVICE && isEmptyContainer;
      return { isAvailable: validState, reason: validState ? '' : `el servicio ya no está en un estado válido. Estados válidos: ${CargoStateDict[CargoStateEnum.START_SERVICE]}. O el servicio no es un contenedor vacío` };

    }
    const tripType = this.utils.getNestedValue(cargo, 'cargoModel.tripType.name');
    const tripTypeByTab = {
      urbanRoutes: TRIP_TYPES.URBAN,
      lastMileRoutes: TRIP_TYPES.LAST_MILE,
      importRoutes: TRIP_TYPES.IMPORT,
      exportRoutes: TRIP_TYPES.EXPORT,
      internationalRoutes: TRIP_TYPES.INTERNATIONAL,
      nationalRoutes: TRIP_TYPES.NATIONAL
    };
    if (tripTypeByTab[typeList]) {
      const validState = cargo.state === CargoStateEnum.START_SERVICE && tripType === tripTypeByTab[typeList];
      return { isAvailable: validState, reason: validState ? '' : `el servicio ya no está en un estado válido. Estados válidos: ${CargoStateDict[CargoStateEnum.START_SERVICE]}. O el tipo de viaje es incorrecto.` };
    }

    // Finalizadas
    if (typeList === 'loadsFinished') {
      if (cargo.state !== CargoStateEnum.END_SERVICE)
        return { isAvailable: false, reason: `el servicio debe estar en el estado de: ${CargoStateDict[CargoStateEnum.END_SERVICE]}.` };

      if (filters && filters['qualified'] === 'true')
        return { isAvailable: !!cargo.cargoScore, reason: !!cargo.cargoScore ? '' : 'el servicio no tiene calificación.' };

      if (filters && filters['qualified'] === 'false')
        return { isAvailable: !(!!cargo.cargoScore), reason: !(!!cargo.cargoScore) ? '' : 'el servicio ya tiene calificación.' };

      return { isAvailable: true, reason: "" };
    }

    //Expiradas
    if (typeList === 'expired') {
      const validState = cargo.state === CargoStateEnum.EXPIRED;
      return { isAvailable: validState, reason: validState ? '' : `el servicio ya no está en un estado válido. Estados válidos: ${CargoStateDict[CargoStateEnum.EXPIRED]}` };
    }

    //Eliminadas
    if (typeList === 'deleted') {
      const validState = cargo.state === CargoStateEnum.DELETED;
      return { isAvailable: validState, reason: validState ? '' : `el servicio ya no está en un estado válido. Estados válidos: ${CargoStateDict[CargoStateEnum.DELETED]}` };
    }

    //Gastos e ingresos
    if (typeList === 'withoutPayment') {
      let allowedStates = [CargoStateEnum.START_SERVICE, CargoStateEnum.END_SERVICE];
      if (!allowedStates.includes(cargo.state))
        return {
          isAvailable: false,
          reason: `el servicio ya no está en un estado válido. Estados válidos: ${allowedStates.map(state => CargoStateDict[state]).join(',')}.`
        };
      return { isAvailable: true, reason: "" };
    }

    //Facturación
    if (typeList === 'charges') {
      let allowedStates = [CargoStateEnum.START_SERVICE, CargoStateEnum.END_SERVICE, CargoStateEnum.ACCEPTED];
      if (!allowedStates.includes(cargo.state))
        return {
          isAvailable: false,
          reason: `el servicio ya no está en un estado válido. Estados válidos: ${allowedStates.map(state => CargoStateDict[state]).join(',')}.`
        };

      const cashed: boolean = this.utils.getNestedValue(cargo, 'shippingCost.cashed');
      const checked: boolean = this.utils.getNestedValue(cargo, 'shippingCost.checked');
      const approval: string = this.utils.getNestedValue(cargo, 'approval');
      if (filters && filters['cashed'] === 'false' && cashed) {
        return {
          isAvailable: false,
          reason: 'el servicio ya está facturado.'
        };
      }
      if (filters && filters['cashed'] === 'true' && !cashed) {
        return {
          isAvailable: false,
          reason: 'el servicio no está facturado.'
        };
      }
      if (filters && filters['checked'] === 'false' && checked)
        return {
          isAvailable: false,
          reason: 'el servicio con comprobante.'
        };
      if (filters && filters['checked'] === 'true' && !checked)
        return {
          isAvailable: false,
          reason: 'el servicio sin comprobante.'
        };
      if (filters && filters['approval'] === 'Pending approval' && approval !== ApprovalStateEnum.PENDING) {
        return {
          isAvailable: false,
          reason: 'el servicio no está pendiente de aprobación.'
        };
      }
      if (filters && filters['approval'] === 'Approved' && approval !== ApprovalStateEnum.APPROVED) {
        return {
          isAvailable: false,
          reason: 'el servicio no está aprobado.'
        };
      }
      if (filters && filters['approval'] === 'Rejected' && approval !== ApprovalStateEnum.REJECTED) {
        return {
          isAvailable: false,
          reason: 'el servicio no está rechazado.'
        };
      }
      return { isAvailable: true, reason: "" };
    }

    //Aprobación
    if (typeList === 'approvePayments') {
      if (cargo.state !== CargoStateEnum.END_SERVICE)
        return { isAvailable: false, reason: `el servicio debe estar en el estado de: ${CargoStateDict[CargoStateEnum.END_SERVICE]}.` };
      if (filters && filters['paid'] === 'true' && !(cargo.shippingCost && cargo.shippingCost.paid))
        return {
          isAvailable: false,
          reason: 'el servicio no está pagado.'
        };
      if (filters && filters['paid'] === 'false' && (cargo.shippingCost && cargo.shippingCost.paid))
        return {
          isAvailable: false,
          reason: 'el servicio está pagado.'
        };
      if (filters && filters['approval'] === 'Pending approval') {
        const validState = cargo.approval === ApprovalStateEnum.PENDING;
        return { isAvailable: validState, reason: validState ? '' : `el servicio ya no está en un estado de aprobación válido. Estados válidos: ${CargoStateDict[ApprovalStateEnum.PENDING]}` };
      }
      if (filters && filters['approval'] === 'Approved') {
        const validState = cargo.approval === ApprovalStateEnum.APPROVED;
        return { isAvailable: validState, reason: validState ? '' : `el servicio ya no está en un estado de aprobación válido. Estados válidos: ${CargoStateDict[ApprovalStateEnum.APPROVED]}` };
      }
      if (filters && filters['approval'] === 'Rejected') {
        const validState = cargo.approval === ApprovalStateEnum.REJECTED;
        return { isAvailable: validState, reason: validState ? '' : `el servicio ya no está en un estado de aprobación válido. Estados válidos: ${CargoStateDict[ApprovalStateEnum.REJECTED]}` };
      }
      return { isAvailable: true, reason: "" };
    }

    //Cumplidos RNDC
    if (typeList === 'rndcFulfillments') {
      if (cargo.state !== CargoStateEnum.END_SERVICE)
        return { isAvailable: false, reason: `el servicio debe estar en el estado de: ${CargoStateDict[CargoStateEnum.END_SERVICE]}.` };
      if (this.utils.isDefined(cargo.ministryFulfillment) && cargo.ministryFulfillment === true)
        return { isAvailable: false, reason: 'el servicio ya está cumplido ante el RNDC.' };
      if (!this.utils.isDefined(cargo.ministryFulfillment) && cargo.approval === ApprovalStateEnum.APPROVED)
        return { isAvailable: false, reason: 'el servicio ya está cumplido ante el RNDC.' };
      return { isAvailable: true, reason: "" };
    }

    //Consultar viáticos
    if (typeList === 'travelExpensesChecking') {
      let unallowedStates = [CargoStateEnum.EXPIRED, CargoStateEnum.DELETED];
      if (unallowedStates.includes(cargo.state)) {
        return {
          isAvailable: false,
          reason: 'el servicio está en un estado inválido.'
        };
      }
      const travelExpenseGlobalStatus = this.utils.getNestedValue(cargo, 'cargoModel.travelExpenseGlobalStatus');
      if (filters && filters['travelExpenseGlobalStatus'] === 'notLegalized') {
        const validState = travelExpenseGlobalStatus === TravelExpensesStateEnum.NOT_LEGALIZED;
        return { isAvailable: validState, reason: validState ? '' : `el servicio ya no está en un estado global de viáticos válido. Estados válidos: ${CargoStateDict[TravelExpensesStateEnum.NOT_LEGALIZED]}` };
      }
      if (filters && filters['travelExpenseGlobalStatus'] === 'legalized') {
        const validState = travelExpenseGlobalStatus === TravelExpensesStateEnum.LEGALIZED;
        return { isAvailable: validState, reason: validState ? '' : `el servicio ya no está en un estado global de viáticos válido. Estados válidos: ${CargoStateDict[TravelExpensesStateEnum.LEGALIZED]}` };
      }
      if (filters && filters['travelExpenseGlobalStatus'] === 'readyToValidate') {
        const validState = travelExpenseGlobalStatus === TravelExpensesStateEnum.READY_TO_VALIDATE;
        return { isAvailable: validState, reason: validState ? '' : `el servicio ya no está en un estado global de viáticos válido. Estados válidos: ${CargoStateDict[TravelExpensesStateEnum.READY_TO_VALIDATE]}` };
      }
      if (filters && filters['travelExpenseGlobalStatus'] === 'partiallyLegalized') {
        const validState = travelExpenseGlobalStatus === TravelExpensesStateEnum.PARTIALLY_LEGALIZED;
        return { isAvailable: validState, reason: validState ? '' : `el servicio ya no está en un estado global de viáticos válido. Estados válidos: ${CargoStateDict[TravelExpensesStateEnum.PARTIALLY_LEGALIZED]}` };
      }
      return { isAvailable: false, reason: 'el servicio está en un estado inválido.' };
    }

    //Pago de anticipos
    if (typeList === 'paymentAdvanceCargo') {
      const allowedStates = [CargoStateEnum.START_SERVICE, CargoStateEnum.ACCEPTED];
      if (!allowedStates.includes(cargo.state))
        return {
          isAvailable: false,
          reason: `el servicio ya no está en un estado válido. Estados válidos: ${allowedStates.map(state => CargoStateDict[state]).join(',')}.`
        };
      const requestedAdvance: boolean = this.utils.getNestedValue(cargo, 'shippingCost.requestedAdvance.requested');
      const advanceState: boolean = this.utils.getNestedValue(cargo, 'shippingCost.advanceState');
      if (filters && filters['requestedAdvance'] === 'true' && !requestedAdvance)
        return {
          isAvailable: false,
          reason: 'el servicio no tiene anticipo solicitado.'
        };
      if (filters && filters['requestedAdvance'] === 'false' && requestedAdvance)
        return {
          isAvailable: false,
          reason: 'el servicio tiene anticipo solicitado.'
        };
      if (filters && filters['advanceState'] === 'false' && advanceState) {
        return {
          isAvailable: false,
          reason: 'el servicio tiene estado de anticipo.'
        };
      }
      if (filters && filters['advanceState'] === 'true' && !advanceState)
        return {
          isAvailable: false,
          reason: 'el servicio no tiene estado de anticipo.'
        };
      return { isAvailable: true, reason: "" };
    }

    //Pago de extra-anticipos
    if (typeList === 'paymentExtraAdvanceCargo') {
      const advanceState: boolean = this.utils.getNestedValue(cargo, 'shippingCost.advanceState');
      return { isAvailable: !!advanceState, reason: !!advanceState ? '' : 'el servicio no tiene un estado de anticipo' };
    }

    //Pago de saldos
    if (typeList === 'paymentBalanceCargo') {
      const allowedStates = [CargoStateEnum.END_SERVICE];
      if (!allowedStates.includes(cargo.state))
        return {
          isAvailable: false,
          reason: `el servicio ya no está en un estado válido. Estados válidos: ${allowedStates.map(state => CargoStateDict[state]).join(',')}.`
        };
      if (filters && filters['approval'] === 'Approved' && cargo.approval !== ApprovalStateEnum.APPROVED)
        return {
          isAvailable: false,
          reason: 'el servicio no está aprobado.'
        };
      const paid: boolean = this.utils.getNestedValue(cargo, 'shippingCost.paid');
      const balanceState: boolean = this.utils.getNestedValue(cargo, 'shippingCost.balanceState');
      if (filters && filters['paid'] === 'true' && paid)
        return {
          isAvailable: false,
          reason: 'el servicio está pagado.'
        };
      if (!filters['paid'] && paid)
        return {
          isAvailable: false,
          reason: 'el servicio está pagado.'
        };
      if (filters && filters['paymentType'] === 'balance' && balanceState)
        return {
          isAvailable: false,
          reason: 'el servicio tiene estado de saldo.'
        };
      if (!filters['paymentType'] && !balanceState)
        return {
          isAvailable: false,
          reason: 'el servicio no tiene estado de saldo.'
        };
      if (filters && filters['fastPayment'] === 'true' && !cargo.fastPayment)
        return {
          isAvailable: false,
          reason: 'el servicio no tiene pronto pago.'
        };
      return { isAvailable: true, reason: "" };
    }

    //Pago de servicios adicionales
    if (typeList === 'paymentAdditionalCostsCargo') {
      const allowedStates = [CargoStateEnum.END_SERVICE, CargoStateEnum.START_SERVICE];

      if (!allowedStates.includes(cargo.state))
        return {
          isAvailable: false,
          reason: `el servicio ya no está en un estado válido. Estados válidos: ${allowedStates.map(state => CargoStateDict[state]).join(',')}.`
        };
      const additionalCosts = this.utils.getNestedValue(cargo, 'additionalCosts') || [];
      if (filters && filters['additionalCostPaid'] === 'true') {
        const everyAdditionalCostPaid = additionalCosts && additionalCosts.length && additionalCosts.every(additionalCost => !!this.utils.getNestedValue(additionalCost, 'financialInformation.paid'));
        return {
          isAvailable: everyAdditionalCostPaid,
          reason: everyAdditionalCostPaid ? '' : 'el servicio tiene servicios adicionales sin pagar.'
        };
      }

      if (filters && filters['additionalCost'] === 'Stand by') {
        const standByPaid = additionalCosts && additionalCosts.length && additionalCosts.some(additionalCost => this.utils.getNestedValue(additionalCost, 'type.name') === 'Stand by' && !this.utils.getNestedValue(additionalCost, 'financialInformation.paid'));
        return {
          isAvailable: standByPaid,
          reason: standByPaid ? '' : 'el servicio tiene stand by sin pagar.'
        };
      }
      if (filters && filters['additionalCost'] === 'Servicio cargue') {
        const loadServicePaid = additionalCosts && additionalCosts.length && additionalCosts.some(additionalCost => this.utils.getNestedValue(additionalCost, 'type.name') === 'Servicio cargue' && !this.utils.getNestedValue(additionalCost, 'financialInformation.paid'));
        return {
          isAvailable: loadServicePaid,
          reason: loadServicePaid ? '' : 'el servicio tiene servicio(s) de cargue sin pagar.'
        };
      }
      if (filters && filters['additionalCost'] === 'Servicio descargue') {
        const downloadServicePaid = additionalCosts && additionalCosts.length && additionalCosts.some(additionalCost => this.utils.getNestedValue(additionalCost, 'type.name') === 'Servicio descargue' && !this.utils.getNestedValue(additionalCost, 'financialInformation.paid'));
        return {
          isAvailable: downloadServicePaid,
          reason: downloadServicePaid ? '' : 'el servicio tiene servicio(s) de descargue sin pagar.'
        };
      }
      return { isAvailable: true, reason: "" };
    }

    return { isAvailable: true, reason: "" };
  }

  public getAllCompanies() {

    return this._http.get<Company[]>(
      environment.urlServerTeclogi + this._endpointResources.getAllCompanies
    );
  }

  public linkServices(data: LinkedServiceDto) {
    return this._http.post(
      environment.urlServerTeclogi + this._endpointResources.linkServices,
      data
    );
  }

  public unlinkConsolidatedService(consecutiveMainCargo: number) {
    let params = new HttpParams();
    params = params.append('consecutiveMainCargo', `${consecutiveMainCargo}`);
    return this._http.post(
      environment.urlServerTeclogi + this._endpointResources.unlinkConsolidatedService,
      null,
      { params }
    );
  }

  get isTeclogiUser(): boolean {
    return this.authService && this.authService.getCompany().companyId === environment.rootNit;
  }

  public replicateService(sourceCargoId: string, consecutives: string[]) {
    return this._http.post(
      `${environment.urlServerTeclogi}${Fmt.string(this._endpointResources.replicateService, sourceCargoId)}`,
      consecutives
    );
  }

  public getTotalValueAdvanceCargos(cargos: Cargo[]): number {
    let value = 0;
    cargos.forEach((cargo: Cargo) => {
      if (!cargo || !cargo.shippingCost) return;
      const balanceState = !!this.utils.getNestedValue(cargo, 'shippingCost.balanceState');
      const travelExpensesBalance = this.cargoPaymentsService.getTravelExpensesBalance(cargo.travelExpenses, cargo);
      const balance = balanceState
        ? this.cargoItemService.getCargoBalancePaid(cargo)
        : this.cargoPaymentsService.getTotalValueBalance(cargo) - travelExpensesBalance;
      value += this.cargoItemService.getPayableAdvance(cargo, balance);
    });
    return parseFloat(value.toString());
  }

  public async getTotalValueTravelExpenses(cargos: Cargo[]): Promise<Array<{ cargo: Cargo, travelExpenses: TravelExpense[] }>> {
    const result: Array<{ cargo: Cargo, travelExpenses: TravelExpense[] }> = [];

    for (const cargo of cargos) {
      let travelExpenses: TravelExpense[] = [];
      try {
        travelExpenses = await this.travelExpensesService.byCargoId(cargo.id).toPromise();
      } catch (error) {
        result.push({ cargo, travelExpenses: [] });
      }
      result.push({ cargo, travelExpenses: travelExpenses && travelExpenses.length ? travelExpenses : [] });
    }
    return result;
  }

  public getTravelExpensesBalance(travelExpenses: Array<TravelExpense>): number {
    const totalPaid = travelExpenses
      .filter(travelExpense => travelExpense.paid)
      .reduce((acc, travelExpense: TravelExpense) => acc + travelExpense.totalPaid, 0);

    const totalValidSpent = travelExpenses
      .map(travelExpenses => travelExpenses.travelExpensesDetail)
      .reduce((acc, travelExpenseDetails: Array<TravelExpenseDetail>) => acc.concat(travelExpenseDetails), [])
      .filter(travelExpenseDetail => travelExpenseDetail.approval === ApprovalStateEnum.APPROVED)
      .reduce((acc, travelExpenseDetail) => acc + travelExpenseDetail.value, 0);

    return totalPaid - totalValidSpent;
  }

  public async getTotalTravelExpensesBalance(cargos: Cargo[]) {
    let value = 0;
    const promises = [];

    cargos.forEach(
      (cargo: Cargo) => {
        const promise = this.travelExpensesService
          .byCargoId(cargo.id)
          .toPromise();
        promises.push(promise);
      }
    );

    const results: Array<Array<TravelExpense>> = await Promise.all(promises);
    if (Array.isArray(results))
      results.forEach(
        (travelExpenses: Array<TravelExpense>) => {
          if (Array.isArray(travelExpenses)) {
            value += this.getTravelExpensesBalance(travelExpenses);
          }
        }
      );

    return parseFloat(value.toString());
  }

  public async getTotalValueBalanceCargos(cargos: Cargo[]): Promise<number> {
    let value = 0;
    const promises = cargos.map((cargo: Cargo) => this.cargoPaymentsService.getBalance(cargo, false, cargo.travelExpenses));
    const results = await Promise.all(promises);
    value = results.reduce((prev, curr) => prev + curr);
    return parseFloat(value.toString());
  }

  public getTotalValueRateCargos(cargos: Cargo[]): number {
    // let value = 0;
    // cargos.map((cargo: Cargo) => {
    //     value += cargo.shippingCost.rate;
    // });
    // return parseFloat(value.toString());
    let totalBill: number = 0;
    cargos.forEach((cargo) => {
      totalBill += this.getTotalValueRateCargo(cargo);
    });
    return totalBill;
  }

  public totalValueUploadCargos(cargos: Cargo[]): number {
    let total: number = 0;
    cargos.forEach((cargo) => {
      if (cargo.additionalCosts && cargo.additionalCosts.length) {
        total = cargo.additionalCosts.filter((additionalCost) => {
          return additionalCost.type.name === 'Servicio cargue';
        }).reduce((accum, item) => item.financialInformation && item.financialInformation.cost ? accum + item.financialInformation.cost : accum, 0);
      }
    });
    return total;
  }

  public totalValueDownloadCargos(cargos: Cargo[]): number {
    let total: number = 0;
    cargos.forEach((cargo) => {
      if (cargo.additionalCosts && cargo.additionalCosts.length) {
        total = cargo.additionalCosts.filter((additionalCost) => {
          return additionalCost.type.name === 'Servicio descargue';
        }).reduce((accum, item) => item.financialInformation && item.financialInformation.cost ? accum + item.financialInformation.cost : accum, 0);
      }
    });
    return total;
  }

  public totalValueStandByCargos(cargos: Cargo[]): number {
    let total: number = 0;
    cargos.forEach((cargo) => {
      if (cargo.additionalCosts && cargo.additionalCosts.length) {
        total = cargo.additionalCosts.filter((additionalCost) => {
          return additionalCost.type.name === 'Stand by';
        }).reduce((accum, item) => item.financialInformation && item.financialInformation.cost ? accum + item.financialInformation.cost : accum, 0);
      }
    });
    return total;
  }

  public getTotalValueRateCargo(cargo: Cargo): number {
    // let value = 0;
    // cargos.map((cargo: Cargo) => {
    //     value += cargo.shippingCost.rate;
    // });
    // return parseFloat(value.toString());
    let isRootNit = this.authService && this.authService.getCompany().companyId === environment.rootNit;
    let rate: number = 0;
    let totalBill: number = 0;
    let rateAdditional: number = 0;
    let rteFte: number = 0;
    let iva: number = 0;
    // if (cargo && cargo.shippingCost && cargo.shippingCost.productSiigo) {
    if (cargo && cargo.shippingCost) {
      rate = cargo.shippingCost.rate;
      totalBill += rate;
      if (cargo.additionalCosts && cargo.additionalCosts.length) {
        cargo.additionalCosts.forEach((additionalCost: AdditionalCostCargo) => {
          if (additionalCost.financialInformation && additionalCost.financialInformation.rate) {
            rateAdditional = additionalCost.financialInformation.rate;
          };
          if (additionalCost.type && additionalCost.type.billingTaxes) {
            additionalCost.type.billingTaxes.forEach((tax: Tax) => {
              const valuePercentage = this.utils.getPercentage(rateAdditional, tax.percentage);
              switch (tax.name) {
                case 'IVA 19%':
                  iva = valuePercentage;
                  break;
                case 'Retefuente 4%':
                  rteFte = valuePercentage;
                  break;
              }
            });
          }
          if (sessionStorage.getItem('_activeTab') === 'charges') {
            //if (isRootNit) rateAdditional = (rateAdditional + iva - rteFte);
          }
          totalBill += rateAdditional;
        });
      }
    }
    return totalBill;
  }

  isPaymentCargo(typeList: string): boolean {
    switch (typeList) {
      case 'paymentAdvanceCargo':
      case 'paymentExtraAdvanceCargo':
      case 'paymentAdditionalCostsCargo':
      case 'paymentBalanceCargo':
      case 'paymentTravelExpenses':
        return true;
    }
    return false;
  }

  isTravelExpensePayment(typeList: string): boolean {
    return typeList == 'paymentTravelExpenses';
  }

  getPaymentType(typeList: string): string {
    switch (typeList) {
      case 'paymentAdvanceCargo':
        return 'advance';
      case 'paymentExtraAdvanceCargo':
        return 'extraAdvance';
      case 'paymentAdditionalCostsCargo':
        return 'additionalCost';
      case 'paymentBalanceCargo':
        return 'balance';
    }
  }

  public sendReport(nitCompany, emails: EmailStructure[]) {
    let dateLoad = DateManager.dateToString(DateManager.substract(new Date(), 20, 'days'), 'YYYY-MM-DD ZZ');
    let endDate = DateManager.dateToString(new Date(), 'YYYY-MM-DD ZZ');
    return this._http.post(
      environment.urlServerTeclogi + this._endpointResources.sendReport + nitCompany + "?reportType=lastPoint&dateLoad=" + dateLoad + "&endDate=" + endDate,
      emails,
      { responseType: 'blob' }
    );
  }

  public getTotalAdditionalCosts(cargos: Cargo[]): number {
    let total: number = 0;
    cargos.forEach((cargo) => {
      if (cargo.additionalCosts && cargo.additionalCosts.length) {
        total += cargo.additionalCosts.filter((additionalCost) => {
          return (additionalCost.type.name === 'Servicio cargue' || additionalCost.type.name === 'Servicio descargue');
        }).reduce((accum, item) => item.financialInformation && item.financialInformation.cost && !item.financialInformation.paid ? accum + item.financialInformation.cost : accum, 0);
      }
    });
    return total;
  }

  public getTotalAdditionalCostsStandBy(cargos: Cargo[]): number {
    let total: number = 0;
    cargos.forEach((cargo) => {
      if (cargo.additionalCosts && cargo.additionalCosts.length) {
        total += cargo.additionalCosts.filter((additionalCost) => {
          return additionalCost.type.name === 'Stand by';
        }).reduce((accum, item) => item.financialInformation && item.financialInformation.cost && !item.financialInformation.paid ? accum + item.financialInformation.cost : accum, 0);
      }
    });
    return total;
  }

  public getTotalAdditionals(cargos: Cargo[]): number {
    let total: number = 0;
    cargos.forEach((cargo) => {
      if (cargo.additionalCosts && cargo.additionalCosts.length) {
        let data = cargo.additionalCosts.filter((additionalCost) => {
          return (additionalCost.type.name === 'Servicio cargue' || additionalCost.type.name === 'Servicio descargue');
        });
        total += data.length;
      }
    });
    return total;
  }

  public getTotalAdditionalStandBy(cargos: Cargo[]): number {
    let total: number = 0;
    cargos.forEach((cargo) => {
      if (cargo.additionalCosts && cargo.additionalCosts.length) {
        let data = cargo.additionalCosts.filter((additionalCost) => {
          return (additionalCost.type.name === 'Stand by');
        });
        total += data.length;
      }
    });
    return total;
  }

  public billXML(body) {
    return this._http.post(
      environment.urlServerTeclogi + this._endpointResources.billXML,
      body,
    );
  }

  canPayExtraAdvance(typeList: string): SelectableItem {
    const extraAdvancePaymentPermission = this.permissionRole.hasPermission(
      this.permission.payments.module,
      this.permission.payments.paymentExtraAdvance
    )
    return { isSelectable: typeList === 'paymentExtraAdvanceCargo' && extraAdvancePaymentPermission };
  }

  isCargoToPayExtraAdvance(cargo: Cargo, typeList: string): SelectableItem {
    const canPayExtraAdvance = this.canPayExtraAdvance(typeList);
    if (!canPayExtraAdvance.isSelectable) return canPayExtraAdvance;
    if (!cargo || !cargo.validatedBankAccount)
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} no tiene cuenta bancaria validada` };

    if (cargo.shippingCost && (cargo.shippingCost.balanceState || cargo.shippingCost.paid))
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} ya tiene el saldo pagado. No es posible generar sobreanticipos` };

    const hasPermissionFinancialActionsAfterApproval = this.permissionRole.hasPermission(
      Permission.payments.module,
      Permission.payments.financialActionsAfterApproval
    );
    if (cargo && cargo.approval === 'Approved' && !hasPermissionFinancialActionsAfterApproval)
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} está aprobado y no tienes permisos para pagar sobre anticipos de servicios aprobados` };
    return { isSelectable: true, isEnabled: true };
  }

  canCharge(typeList: string): boolean {
    return typeList === 'charges';
  }

  canBill(typeList: string, filters: string): SelectableItem {
    return { isSelectable: typeList === 'charges' && filters.includes('cashed=false') };
  }

  isCargoToBill(cargo: Cargo, typeList: string, filters: string, isPreBill: boolean = false): SelectableItem {
    const canBill = this.canBill(typeList, filters);
    if (!canBill.isSelectable) return canBill;
    if (!cargo || !cargo.shippingCost) return { isSelectable: false };
    if (cargo.shippingCost.cashed)
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} ya ha sido facturado` };
    if (![CargoStateEnum.END_SERVICE, CargoStateEnum.START_SERVICE].includes(cargo.state))
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} no está habilitado para facturación` };
    const requiresPreValidation = this.authService && this.authService.hasCompanySettingEnabled(SettingId.REQUIRES_PRE_VALIDATION);
    if (requiresPreValidation && (!cargo.prevalidation || !cargo.prevalidation.valid))
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} no ha sido validado` };
    if (isPreBill && !cargo.preBill)
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} no tiene prefactura asociada` };
    return { isSelectable: true, isEnabled: true };
  }

  canPayTravelExpenses(typeList: string): SelectableItem {
    const hasPermissionToPayTravelExpenses = this.permissionRole.hasPermission(
      this.permission.payments.module,
      this.permission.payments.paymentTravelExpenses
    );
    return { isSelectable: typeList === 'paymentTravelExpenses' && hasPermissionToPayTravelExpenses };
  }

  isCargoToPayTravelExpenses(cargo: Cargo, typeList: string, filters: string): SelectableItem {
    const canPayTravelExpenses = this.canPayTravelExpenses(typeList);
    if (!canPayTravelExpenses.isSelectable) return canPayTravelExpenses;
    if (!cargo || !cargo.confirmedDriver)
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} no tiene conductor confirmado` };
    if (!cargo || !cargo.validatedBankAccount)
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} no tiene cuenta bancaria validada` };
    if (filters && filters.includes('paid=true'))
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} ya tiene sus viáticos pagados` };
    const travelExpenses: Array<TravelExpense> = this.utils.getNestedValue(cargo, 'travelExpenses');
    if (!travelExpenses || !travelExpenses.length) return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} no tiene viáticos` };
    return { isSelectable: true, isEnabled: true };
  }

  canGenerateJournal(typeList: string): SelectableItem {
    const hasPermissionToGenerateJournal = this.permissionRole.hasPermission(
      this.permission.payments.module,
      this.permission.payments.generateJournalCargo
    );
    return { isSelectable: typeList === 'withoutPayment' && hasPermissionToGenerateJournal };
  }

  isCargoToGenerateJournal(cargo: Cargo, typeList: string): SelectableItem {
    const canGenerateJournal = this.canGenerateJournal(typeList);
    if (!canGenerateJournal.isSelectable) return canGenerateJournal;
    return { isSelectable: true, isEnabled: true };
  }

  canPayAdvance(typeList: string): SelectableItem {
    const hasPermissionToPayAdvance = this.permissionRole.hasPermission(
      this.permission.payments.module,
      this.permission.payments.paymentAdvance
    );
    const hasPermissionToPayAdvanceUnrestricted = this.permissionRole.hasPermission(
      this.permission.payments.module,
      this.permission.payments.unrestrictedAdvancePayments
    );
    return { isSelectable: typeList === 'paymentAdvanceCargo' && (hasPermissionToPayAdvance || hasPermissionToPayAdvanceUnrestricted) };
  }

  isCargoToPayAdvance(cargo: Cargo, typeList: string, filters: string): SelectableItem {
    const canPayAdvance = this.canPayAdvance(typeList);
    if (!canPayAdvance.isSelectable) return canPayAdvance;
    if (filters && filters.includes('advanceState=true') && filters.includes('paymentType=advance'))
      return { isSelectable: false };
    if (!cargo || !cargo.confirmedDriver)
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} no tiene conductor confirmado` };
    if (!cargo || !cargo.validatedBankAccount)
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} no tiene cuenta bancaria validada` };

    return { isSelectable: true, isEnabled: true };
  }

  canPayBalance(typeList: string): SelectableItem {
    const hasPermissionToPayBalance = this.permissionRole.hasPermission(
      this.permission.payments.module,
      this.permission.payments.paymentBalance
    );
    return { isSelectable: typeList === 'paymentBalanceCargo' && hasPermissionToPayBalance };
  }

  isCargoToPayBalance(cargo: Cargo, typeList: string, filters: string): SelectableItem {
    const canPayBalance = this.canPayBalance(typeList);
    if (!canPayBalance.isSelectable) return canPayBalance;
    if (!cargo || !cargo.validatedBankAccount)
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} no tiene cuenta bancaria validada` };
    if (cargo && cargo.unlegalizedTravelExpense)
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} tiene viáticos pendientes por legalizar` };
    if (!cargo || !cargo.shippingCost || !cargo.shippingCost.approveBalance)
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} no tiene aprobado el pago del saldo` };
    if (this.canPaySoon(typeList, filters))
      return this.isCargoPaySoon(cargo);
    return { isSelectable: true, isEnabled: true };
  }

  canPayAdditionalCosts(typeList: string): SelectableItem {
    const hasPermissionToPayAdditionalCosts = this.permissionRole.hasPermission(
      this.permission.payments.module,
      this.permission.payments.paymentAdditionalCosts
    );
    return { isSelectable: typeList === 'paymentAdditionalCostsCargo' && hasPermissionToPayAdditionalCosts };
  }

  isCargoToPayAdditionalCosts(cargo: Cargo, typeList: string, filters: string): SelectableItem {
    const canPayAdditionalCosts = this.canPayAdditionalCosts(typeList);
    if (!canPayAdditionalCosts.isSelectable) return canPayAdditionalCosts;
    if (filters && filters.includes('additionalCostPaid=true'))
      return { isSelectable: false };
    if (!cargo || !cargo.validatedBankAccount)
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} no tiene cuenta bancaria validada` };
    return { isSelectable: true, isEnabled: true };
  }

  canPaySoon(typeList: string, filters: string): boolean {
    return typeList === 'paymentBalanceCargo' && filters.search('fastPayment=true') >= 0;
  }

  isCargoPaySoon(cargo: Cargo): SelectableItem {
    if (!cargo || cargo.approval !== 'Approved') return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} no ha sido aprobado` };
    if (cargo.state !== CargoStateEnum.END_SERVICE) return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} no ha finalizado` };
    if (cargo.shippingCost && cargo.shippingCost.paid) return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} ya ha sido pagado` };
    return { isSelectable: true, isEnabled: true };
  }

  canFulfillRndc(typeList: string, filters: string): SelectableItem {
    const permissionToFulfillRndc = this.permissionRole.hasPermission(
      this.permission.payments.module,
      this.permission.payments.fulFillCargosRndc
    );
    return { isSelectable: typeList === 'rndcFulfillments' && permissionToFulfillRndc && !filters.includes('ministryFulfillment=true') };
  }

  isCargoToRndcFulfill(typeList: string, cargo: Cargo, filters: string): SelectableItem {
    const canFulfillRndc = this.canFulfillRndc(typeList, filters);
    if (!canFulfillRndc.isSelectable) return canFulfillRndc;
    if (isDocumentRecreationInProgress(cargo))
      return {
        isSelectable: true,
        isEnabled: false,
        errorMessage: `${DOCUMENT_RECREATION_IN_PROGRESS_MESSAGE} Servicio ${cargo.consecutive}.`
      };
    if (cargo.state !== CargoStateEnum.END_SERVICE)
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} no ha finalizado` };
    if (!cargo.ministry)
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} no requiere manifiesto` };
    if (!cargo.manifestAuthorization)
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} no tiene autorización de manifiesto` };
    if (this.utils.isDefined(cargo.ministryFulfillment) && cargo.ministryFulfillment === true)
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} ya está cumplido ante el RNDC` };
    if (!this.utils.isDefined(cargo.ministryFulfillment) && cargo.approval === ApprovalStateEnum.APPROVED)
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} ya está cumplido ante el RNDC` };
    return { isSelectable: true, isEnabled: true };
  }

  isCargoToApproveOrDisapprove(typeList: string): SelectableItem {
    const hasPermissionToApprove = this.permissionRole.hasPermission(
      this.permission.payments.module,
      this.permission.payments.approvePayments
    );
    return { isSelectable: typeList === 'approvePayments' && hasPermissionToApprove };
  }

  isCargoToApprove(cargo: Cargo, typeList: string): SelectableItem {
    const canApprove = this.isCargoToApproveOrDisapprove(typeList);
    if (!canApprove.isSelectable) return canApprove;
    if (CargoStateEnum.END_SERVICE !== cargo.state)
      return { isSelectable: false };
    if (cargo && cargo.approval === 'Approved')
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} ya ha sido aprobado` };

    const hasPermissionToApproveWithTravelExpensesPending = this.permissionRole.hasPermission(
      this.permission.payments.module,
      this.permission.payments.approvePaymentsWithTravelExpensesPending
    )
    if (cargo && cargo.unlegalizedTravelExpense && !hasPermissionToApproveWithTravelExpensesPending)
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} tiene viáticos pendientes por legalizar y no tienes permisos para aprobarlo` };

    return { isSelectable: true, isEnabled: true };
  }

  isCargoToDisapprove(cargo: Cargo, typeList: string): SelectableItem {
    const canDisapprove = this.isCargoToApproveOrDisapprove(typeList);
    if (!canDisapprove.isSelectable) return canDisapprove;
    if (CargoStateEnum.END_SERVICE !== cargo.state)
      return { isSelectable: false };
    if (cargo && cargo.approval === 'Rejected')
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} ya ha sido rechazado` };

    return { isSelectable: true, isEnabled: true };
  }

  isCargoToReverse(cargo: Cargo, typeList: string): SelectableItem {
    const canReverse = this.isCargoToApproveOrDisapprove(typeList);
    if (!canReverse.isSelectable) return canReverse;

    if (cargo && cargo.approval !== 'Approved' && cargo.approval !== 'Rejected')
      return { isSelectable: true, isEnabled: false, errorMessage: `El servicio ${cargo.consecutive} no ha sido aprobado ni rechazado` };

    return { isSelectable: true, isEnabled: true };
  }

  public loadAvailableToPay(cargo: Cargo, typeList: string, filters: string): SelectableItem {
    if (filters && filters.includes('paid=true'))
      return { isSelectable: false };
    if (!this.utils.enableSelectItemByList(typeList))
      return { isSelectable: false };
    if (this.canCharge(typeList)) {
      if (this.canBill(typeList, filters))
        return this.isCargoToBill(cargo, typeList, filters);
      return { isSelectable: true };
    }
    if (!this.isPaymentCargo(typeList)) return { isSelectable: false };

    const canGenerateJournal = this.canGenerateJournal(typeList);
    if (canGenerateJournal.isSelectable)
      return this.isCargoToGenerateJournal(cargo, typeList);

    const canPayAdditionalCosts = this.canPayAdditionalCosts(typeList);
    if (canPayAdditionalCosts.isSelectable)
      return this.isCargoToPayAdditionalCosts(cargo, typeList, filters);

    const canPayTravelExpenses = this.canPayTravelExpenses(typeList);
    if (canPayTravelExpenses.isSelectable)
      return this.isCargoToPayTravelExpenses(cargo, typeList, filters);

    const canPayBalance = this.canPayBalance(typeList);
    if (canPayBalance.isSelectable)
      return this.isCargoToPayBalance(cargo, typeList, filters);

    const canPayAdvance = this.canPayAdvance(typeList);
    if (canPayAdvance.isSelectable)
      return this.isCargoToPayAdvance(cargo, typeList, filters);

    const canPayExtraAdvance = this.canPayExtraAdvance(typeList);
    if (canPayExtraAdvance.isSelectable)
      return this.isCargoToPayExtraAdvance(cargo, typeList);

    return { isSelectable: false };
  }

  public checkValidationService(cargo: Cargo, typeList: string, filters: string): { isSelectable: boolean, isEnabled: boolean, errorMessage: string } {
    const { isSelectable, isEnabled, errorMessage } = this.loadAvailableToPay(cargo, typeList, filters);
    return { isSelectable, isEnabled, errorMessage }
  }

  public getMonitoringCompanies(): Observable<Catalog> {
    return this._http.get<Catalog>(`${environment.urlServerTeclogi}${this._endpointResources.getMonitoringCompanies}`);
  }

  public getConsolidationTypes(): Observable<Catalog> {
    return this._http.get<Catalog>(`${environment.urlServerTeclogi}${this._endpointResources.getConsolidationTypes}`);
  }

  public getLogisticsTimeReasons() {
    return this._http.get<Catalog>(
      `${environment.urlServerTeclogi}${this._endpointResources.logisticsTimeReasons}`
    );
  }

  /*private CalculateLastTripAnomaly(value) {
    let diff = DateManager.durationFormat(DateManager.dateDiff(value.tripAnomalies[value.tripAnomalies.length - 1].date, "DD/MM/YYYY", new Date(), null, "seconds"), "seconds");
    return diff.days;
  }*/

}
